import { render, staticRenderFns } from "./PhoneReserve.vue?vue&type=template&id=06d40579&scoped=true"
import script from "./PhoneReserve.vue?vue&type=script&lang=js"
export * from "./PhoneReserve.vue?vue&type=script&lang=js"
import style0 from "./PhoneReserve.vue?vue&type=style&index=0&id=06d40579&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "06d40579",
  null
  
)

export default component.exports